import i18n from '@/localisation/i18n';

export const ErrorItem = ({ title }: { title: string }) => {
  return (
    <div className="flex flex-col items-center rounded-[18px] border border-card p-2">
      <img
        className="rounded-xl"
        width={115}
        height={115}
        src={`/errors/${title}.svg`}
        alt="error"
      />
      <div className="w-28 break-words py-2 text-center text-base">
        {i18n.t(title as never)}
      </div>
    </div>
  );
};
